/** Separate build gate for public onboarding; backend participation remains server controlled. */
export function isPublicOnboardingEnabled(): boolean {
  return import.meta.env.VITE_PUBLIC_ONBOARDING_ENABLED !== 'false'
}
